import React from 'react'
import classes from './VisibilityAdornment.module.scss'
import Typography from '@/components/ui/Typography'
import { VisibilityAdornmentProps } from '@/components/ui/VisibilityAdornment/VisibilityAdornment.types'
import { useVisibilityAdornment } from '@/components/ui/VisibilityAdornment/VisibilityAdornment.hooks'
import { Puff } from '@/components/ui/Loaders'

import { ReactComponent as ShowIcon } from '@/assets/icons/eye.svg'
import { ReactComponent as HideIcon } from '@/assets/icons/eye-crossed.svg'

const VisibilityAdornment = ({ initialValue = false, onShow, onHide }: VisibilityAdornmentProps) => {
  const { onClick, isLoading, isVisible } = useVisibilityAdornment({ initialValue, onShow, onHide })

  return (
    <div role="presentation" className={classes.root} onClick={onClick}>
      {isLoading ? <Puff size={16} /> : isVisible ? <HideIcon /> : <ShowIcon />}
      <Typography isBold>{isLoading ? 'Loading' : isVisible ? 'Hide ' : 'Show'}</Typography>
    </div>
  )
}

export default VisibilityAdornment
